export default __webpack_public_path__ + "static/media/card10.16bb70fe.png";